module.exports = __webpack_public_path__ + "img/IMG_3567.ae1cba36.png";